// 报班情况
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
import columns from './colums'
import './index.less'
const { WizSpin } = component_tool
const { WizContainer } = framework_tool

class TrackShiftReport extends WizContainer {

  componentName = 'TrackShiftReport'

  constructor(props) {
    super(props)
    this.state = {
      data: []
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    let { trackTrainingList = [] } = this.props
    let ids = trackTrainingList.map(e => e.programId)
    this.doAction({
      path: 'counselingProcess/getApplyPlanPersonInfoList',
      payload: {
        key: 'getApplyPlanPersonInfoList@list',
        apiParams: {
          personId: trackTrainingList[0].personId,
          programIds: ids
        }
      }
    })
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this)
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '获取报班情况失败')
    return false
  }

  render() {
    let { counselingProcessLoading } = this.props
    let { data } = this.state
    let tableProps = {
      columns: columns(),
      dataSource: recombinationData(data),
      pagination: false,
      bordered: true,
      size: 'small',
      scroll: { x: 'max-content' },
      rowKey: (e, i) => i
    }

    return (
      <WizSpin spinning={counselingProcessLoading} >
        <Table {...tableProps} />
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const list = modelUtils.getModelEntity(counselingProcess, 'getApplyPlanPersonInfoList@list')
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    ...loading
  }
}

export default connect(mapStateToProps)(TrackShiftReport)

const recombinationData = (tableData) => {
  if (tableData.length === 0) return []
  let newData = []
  tableData.map(e => {
    e.applyPlanPersonInfoList.map((c, i) => {
      let obj = {
        rowSpan: i === 0 ? e.applyPlanPersonInfoList.length : 0,
        ...c
      }
      newData.push(obj)
    })
  })
  return newData
}


